// extracted by mini-css-extract-plugin
export default {"_wrapper":"styles__wrapper__kJ3j+","_img":"styles__img__mDVsY","_text":"styles__text__7b9-Q","_button":"styles__button__z9Xkx"};